var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "70px",
    viewBox: "0 0 76 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "60D73A12-1B07-4A94-8046-47FC9EEFF109") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50.-Part-2---SideEffects-UI",
    transform: "translate(-364.000000, -780.000000)",
    strokeWidth: 2.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(366.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.921138,7.306866 C29.385378,5.525586 24.680178,-5.4e-05 24.680178,-5.4e-05 C24.680178,-5.4e-05 19.974978,5.525586 18.439218,7.306686 C7.734618,19.721466 1.8e-05,28.691586 1.8e-05,41.122566 C1.8e-05,54.731286 11.071458,65.802726 24.680178,65.802726 C38.289078,65.802726 49.360158,54.731286 49.360158,41.122566 C49.360158,28.691586 41.625918,19.721646 30.921138,7.306866 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.50202,
    y1: 52.731558,
    x2: 30.43998,
    y2: 52.731558,
    id: "Stroke-3",
    stroke: "#DF6532"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.487902,
    y1: 45.717534,
    x2: 24.487902,
    y2: 57.655494,
    id: "Stroke-5",
    stroke: "#DF6532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.680214,21.950676 C31.222494,21.950676 36.526194,27.007596 36.526194,33.245676 C36.526194,39.483756 31.222494,44.540676 24.680214,44.540676 C18.137754,44.540676 12.834054,39.483756 12.834054,33.245676 C12.834054,27.007596 18.137754,21.950676 24.680214,21.950676 Z",
    id: "Stroke-7",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.745308,
    y1: 42.662106,
    x2: 72.171648,
    y2: 42.662106,
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.458424,
    y1: 33.948972,
    x2: 63.458424,
    y2: 51.375312,
    id: "Stroke-11",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.745308,
    y1: 59.134734,
    x2: 72.171648,
    y2: 59.134734,
    id: "Stroke-13",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPlus);
export default __webpack_public_path__ + "static/media/symbolPlus.dfc01b13.svg";
export { ForwardRef as ReactComponent };